import { withComingSoon } from '../components/hoc/withComingSoon';
import SEO from '../components/common/SEO';
import { useTranslation } from 'react-i18next';

const AskRabbiContent = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO 
        title={t('navigation.askRabbi')}
        description={t('common.comingSoonDescription')}
        keywords={[
          'Ask a Rabbi',
          'Jewish questions',
          'Torah guidance',
          'Halacha questions',
          'Jewish advice',
          'Religious consultation'
        ]}
      />
      {withComingSoon()()}
    </>
  );
};

export default AskRabbiContent; 